import { createStateHook, createNextHook } from '@restate/core'
import { AppStoreProvider } from 'state/store'

export const useUserDetailsState = createStateHook(
  AppStoreProvider,
  state => state.pages.userDetails
)
export const useNextUserDetailsState = () =>
  createNextHook(AppStoreProvider, state => state.pages.userDetails)
